/** 勤務意向確認アンケート（正本: https://forms.gle/GPo4gH2ZYMh93Ay49） */
export const WORK_INTENTION_SURVEY_FORM_SHORT_URL =
  "https://forms.gle/GPo4gH2ZYMh93Ay49";

export const WORK_INTENTION_SURVEY_FORM_BASE_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdd-g1bkuCzBGYWwNFUXT7NvNzsXcTXXHYHZw_gmiM9KAflug/viewform";

/** 運営フォームのワーカー ID 項目（prefill 用） */
export const WORK_INTENTION_SURVEY_WORKER_ID_ENTRY_KEY = "entry.1713944012";

export const WORK_INTENTION_SURVEY_IFRAME_LOAD_TIMEOUT_MS = 10_000;

export const WORK_INTENTION_SURVEY_COPY = {
  title: "勤務意向確認アンケート",
  description:
    "今後の勤務意向についてお聞かせください。回答は任意ですが、ご協力いただけると助かります。",
  closeButton: "閉じる",
  loadError:
    "フォームの読み込みに失敗しました。ブラウザで開いて回答してください。",
  openInBrowser: "ブラウザで開く",
} as const;

type BuildFormUrlOptions = {
  embedded?: boolean;
  workerId?: string | null;
};

export function buildWorkIntentionSurveyFormUrl(
  options: BuildFormUrlOptions = {},
): string {
  const { embedded = false, workerId } = options;
  const params = new URLSearchParams();

  if (embedded) {
    params.set("embedded", "true");
  }

  if (workerId) {
    params.set("usp", "pp_url");
    params.set(WORK_INTENTION_SURVEY_WORKER_ID_ENTRY_KEY, workerId);
  }

  const query = params.toString();
  return query
    ? `${WORK_INTENTION_SURVEY_FORM_BASE_URL}?${query}`
    : WORK_INTENTION_SURVEY_FORM_BASE_URL;
}

export function buildWorkIntentionSurveyEmbedUrl(
  workerId?: string | null,
): string {
  return buildWorkIntentionSurveyFormUrl({ embedded: true, workerId });
}

export function buildWorkIntentionSurveyExternalUrl(
  workerId?: string | null,
): string {
  return buildWorkIntentionSurveyFormUrl({ embedded: false, workerId });
}
